import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

// Function to convert a string to camelCase
const toCamelCase = (str: string): string => {
    return str
        .replace(/[-_](.)/g, (_, char) => char.toUpperCase()) // Convert characters after - or _ to uppercase
        .replace(/^([A-Z])/, (_, char) => char.toLowerCase()) // Ensure the first letter is lowercase
}

const useQueryParam = <T>() => {
    const location = useLocation()
    const parsedQuery = queryString.parse(location.search)

    // Normalize query parameter names to camelCase
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const normalizedQuery: { [key: string]: any } = {}
    Object.keys(parsedQuery).forEach((key) => {
        normalizedQuery[toCamelCase(key)] = parsedQuery[key]
    })

    return normalizedQuery as unknown as T
}

export default useQueryParam
